import { useEffect, useState } from "react";
import Modal from "../../components/Modal/Modal";
import { Action } from "../../components/ToolPage";
import ContextHelp from "../../components/ContextHelp/ContextHelp";
import styles from "./ProjectChooser.module.css";
export function ProjectChooser({
  open,
  projects,
  onChoose,
  onCreateProject,
  onClose,
  loading,
  error,
  preferredProjectId,
}: {
  open: boolean;
  projects: Array<{ id: string; name: string }>;
  onChoose: (id: string) => void;
  onCreateProject: () => void;
  onClose: () => void;
  loading?: boolean;
  error?: string | null;
  preferredProjectId?: string;
}) {
  const [selected, setSelected] = useState("");
  useEffect(() => {
    if (open) setSelected(preferredProjectId || "");
  }, [open, preferredProjectId]);
  return (
    <Modal
      isOpen={open}
      onClose={onClose}
      title="Choose a project"
      size="small"
    >
      <div className={styles.body}>
        <p>Choose where to keep this work.</p>
        <label htmlFor="task-project">Project</label>
        <select
          id="task-project"
          value={selected}
          onChange={(e) => setSelected(e.target.value)}
          disabled={loading}
        >
          <option value="">Select a project</option>
          {projects.map((p) => (
            <option key={p.id} value={p.id}>
              {p.name}
            </option>
          ))}
        </select>
        {error && <p role="alert">{error}</p>}
        <ContextHelp label="Why choose a project?">
          Projects keep related inputs and results together. You can reuse an
          existing project for your next task.
        </ContextHelp>
        <div className={styles.actions}>
          <Action
            action={{ label: "New project", onSelect: onCreateProject }}
          />
          <Action
            primary
            action={{
              label: "Continue",
              onSelect: () => onChoose(selected),
              disabledReason:
                loading || !projects.some((p) => p.id === selected)
                  ? "Select an available project to continue"
                  : undefined,
            }}
          />
        </div>
      </div>
    </Modal>
  );
}
